/**
 * 隐藏字符串 *****
 * @param {String} str 需要处理的字符串
 * @param {Number} frontLen 开始的位置
 * @param {Number} endLen 结束位置
 * @param {String} cha 替代符号
 * @returns {string}
 */
export const hideString = (str, frontLen = 3, endLen = 3, cha = '*') => {
  if (!str) return ""
  const len = str.length - frontLen - endLen;
  let x = '';
  for (let i = 0; i < len; i++) {
    x += cha;
  }
  return str.substring(0, frontLen) + x + str.substring(str.length - endLen);
}

/**
 * 生成随机字符串(可指定长度)
 * @param len
 */
export const randomString = (len) => {
  len = len || 8;
  let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  let maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

/**
 * sha1签名
 * @param obj
 * @returns {*}
 */
export function sha1Sign(obj) {
  const sha1 = require("./sha1.min")
  let arr = Object.values(obj).sort();
  let arrString = "";
  arr.forEach(item => {
    arrString += item;
  });
  return sha1(arrString)
}

/**
 * 遍历拼接参数
 * @param {Object} param 参数
 */
export function splitJointUrl(param = {}) {
  let url = "";
  let query = "";
  for (const key in param) {
    if (param[key] === 0) {
      query += "&" + key + "=" + param[key];
    }
    if (param.hasOwnProperty(key) && !!param[key]) {
      query += "&" + key + "=" + param[key];
    }
  }
  if (query) {
    query = "?" + query.slice(1);
    url += query;
  }
  return url;
}


// base64 转 file
export const dataURLtoFile = (dataUrl, filename = 'face.png') => {
  if (!!dataUrl) {
    let arr = dataUrl.split(",")
    let mime = arr[0].match(/:(.*?);/)[1]
    let bStr
    bStr = atob(arr[1])
    let n = bStr.length
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bStr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
  } else {
    return null;
  }
}

/**
 * 判断是否为 PC 端微信内置浏览器
 * 规则：UA 中包含 MicroMessenger，且不包含常见移动端 UA 关键字
 * @returns {boolean}
 */
export const isPcWeChatBrowser = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isWeChat = /MicroMessenger/i.test(ua);
  const isMobileUA = /(Mobile|Android|iPhone|iPad|iPod|Windows Phone)/i.test(ua);
  return isWeChat && !isMobileUA;
};

export const getQueryStr = (argu) => {
  //查询字符串并去掉开头的问号
  let qs = location.search.length > 0 ? location.search.substring(1) : "";
  console.log(location.search.substring(1));
  //获取每一项
  let items = qs.length ? qs.split("&") : [];
  let key = null,
    value = null;
  for (let i = 0; i < items.length; i++) {
    key = decodeURIComponent(items[i].split("=")[0]);
    value = decodeURIComponent(items[i].split("=")[1]);
    if (key == argu) return value;
  }
};